import {
  MaterialGroupName,
  MaterialGroupingName,
} from "src/store/api/generatedApi";
import { typeSafeObjectKeys } from "src/utils/typeSafeObjectKeys";

/**
 * The API returns groupings in the tenant's configured display order, so the
 * first is the default to show.
 */
export const defaultMaterialGrouping = (
  availableMaterialGroupings: Record<MaterialGroupingName, MaterialGroupName[]>
): MaterialGroupingName | null =>
  typeSafeObjectKeys(availableMaterialGroupings)[0] ?? null;
